(function () {
  var BUNDLE_MAP = {
    "Pack Promenade": [
      {"id":49661979132056,"options":["Noir","S"]},
      {"id":49661979164824,"options":["Noir","M"]},
      {"id":49661979197592,"options":["Noir","L"]},
      {"id":49661979230360,"options":["Noir","XL"]},
      {"id":49661979263128,"options":["Bleu","S"]},
      {"id":49661979295896,"options":["Bleu","M"]},
      {"id":49661979328664,"options":["Bleu","L"]},
      {"id":49661979361432,"options":["Bleu","XL"]},
      {"id":49661979394200,"options":["Beige","S"]},
      {"id":49661979426968,"options":["Beige","M"]},
      {"id":49661979459736,"options":["Beige","L"]},
      {"id":49661979492504,"options":["Beige","XL"]}
    ],
    "Pack Complet": [
      {"id":49661985128600,"options":["Noir","S"]},
      {"id":49661985161368,"options":["Noir","M"]},
      {"id":49661985194136,"options":["Noir","L"]},
      {"id":49661985226904,"options":["Noir","XL"]},
      {"id":49661985259672,"options":["Bleu","S"]},
      {"id":49661985292440,"options":["Bleu","M"]},
      {"id":49661985325208,"options":["Bleu","L"]},
      {"id":49661985357976,"options":["Bleu","XL"]},
      {"id":49661985390744,"options":["Beige","S"]},
      {"id":49661985423512,"options":["Beige","M"]},
      {"id":49661985456280,"options":["Beige","L"]},
      {"id":49661985489048,"options":["Beige","XL"]}
    ]
  };

  function getHarnessOptionValues(panelEl) {
    var row = panelEl.querySelector('[data-pack-harness-row]');
    var selects = row ? Array.prototype.slice.call(row.querySelectorAll('[data-pack-harness-option-index]')) : [];
    return selects.map(function (s) { return s.value; });
  }

  function findVariant(list, optionVals) {
    return list.find(function (v) {
      return v.options.every(function (val, i) { return val === optionVals[i]; });
    }) || null;
  }

  function getActivePanel(packsRoot) {
    var panels = Array.prototype.slice.call(packsRoot.querySelectorAll('[data-pack-panel]'));
    return panels.find(function (p) { return p.style.display !== 'none'; }) || panels[0];
  }

  function openCart() {
    if (window.WoufixCartDrawer && typeof window.WoufixCartDrawer.open === 'function') {
      window.WoufixCartDrawer.open();
      return;
    }
    var cartNotification = document.querySelector('cart-notification');
    if (cartNotification && typeof cartNotification.open === 'function') {
      cartNotification.open();
      return;
    }
    var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    window.location.href = routeRoot.replace(/\/$/, '') + '/cart';
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.classList || !form.classList.contains('product-hero__pack-atc-form')) return;

    var packsRoot = form.closest('[data-packs-root]');
    if (!packsRoot) return;

    var activePanel = getActivePanel(packsRoot);
    if (!activePanel) return;

    var titleEl = activePanel.querySelector('.pack-offer__title');
    var title = titleEl ? titleEl.textContent.trim() : '';
    var bundleVariants = BUNDLE_MAP[title];
    if (!bundleVariants) return;

    event.preventDefault();
    event.stopPropagation();

    var errorEl = packsRoot.querySelector('[data-pack-atc-error]');
    var button = packsRoot.querySelector('[data-pack-atc-button]');
    if (errorEl) { errorEl.style.display = 'none'; errorEl.textContent = ''; }

    var optionVals = getHarnessOptionValues(activePanel);
    var bundleVariant = findVariant(bundleVariants, optionVals);

    if (!bundleVariant) {
      if (errorEl) { errorEl.textContent = 'Une des combinaisons sélectionnées est épuisée.'; errorEl.style.display = 'block'; }
      return;
    }

    if (button) { button.disabled = true; button.classList.add('is-loading'); }

    var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(routeRoot.replace(/\/$/, '') + '/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: bundleVariant.id, quantity: 1 }] })
    })
      .then(function (response) {
        return response.json().then(function (data) { return { ok: response.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) {
          var message = (result.data && (result.data.description || result.data.message)) || 'Une erreur est survenue.';
          if (errorEl) { errorEl.textContent = message; errorEl.style.display = 'block'; }
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        openCart();
      })
      .catch(function () {
        if (errorEl) { errorEl.textContent = 'Une erreur est survenue. Réessayez.'; errorEl.style.display = 'block'; }
      })
      .finally(function () {
        if (button) { button.disabled = false; button.classList.remove('is-loading'); }
      });
  }, true);
})();
